import React, { useState } from "react";
import { Tabs } from "antd";
import { WalletOutlined, AppstoreOutlined } from "@ant-design/icons";
import GestionCategoriesDepenses from "../../gestion-depenses/GestionCategoriesDepenses";
import GestionSaisieDepenses from "../../gestion-depenses/GestionSaisieDepenses";

const { TabPane } = Tabs;

const HOTEL_EXPENSE_PERMISSIONS = {
  categories: {
    VIEW: "Hotellerie.Depenses.Categories.view",
    EDIT: "Hotellerie.Depenses.Categories.edit",
    DELETE: "Hotellerie.Depenses.Categories.delete",
  },
  entries: {
    VIEW: "Hotellerie.Depenses.SaisieDepenses.view",
    CREATE: "Hotellerie.Depenses.SaisieDepenses.create",
    EDIT: "Hotellerie.Depenses.SaisieDepenses.edit",
    DELETE: "Hotellerie.Depenses.SaisieDepenses.delete",
    EXPORT: "Hotellerie.Depenses.SaisieDepenses.export",
    CREATE_PAYMENT: "Hotellerie.Depenses.SaisieDepenses.create_payment",
  },
};

const ExpensesTab: React.FC = () => {
  const [activeTab, setActiveTab] = useState("entries");

  return (
    <Tabs
      activeKey={activeTab}
      onChange={setActiveTab}
      size="large"
      type="card"
    >
      <TabPane
        tab={
          <span>
            <WalletOutlined /> Saisie
          </span>
        }
        key="entries"
      >
        <GestionSaisieDepenses
          moduleScope="hotellerie"
          permissions={HOTEL_EXPENSE_PERMISSIONS.entries}
          title="Saisie des Charges Admin"
        />
      </TabPane>
      <TabPane
        tab={
          <span>
            <AppstoreOutlined /> Categories
          </span>
        }
        key="categories"
      >
        <GestionCategoriesDepenses
          moduleScope="hotellerie"
          permissions={HOTEL_EXPENSE_PERMISSIONS.categories}
          title="Gestion des Categories de Charges Admin"
        />
      </TabPane>
    </Tabs>
  );
};

export default ExpensesTab;
